/** @jsx jsx */
import { jsx } from '@emotion/react';

import {
  ArtIcon,
  BriefcaseIcon,
  CodeIcon,
  GlobeIcon,
  HealthIcon,
  LaptopIcon,
  LaunchIcon,
  MathIcon,
  MembersIcon,
  ScienceIcon,
  TrendingIcon,
} from '@coursera/cds-icons';

type Props = {
  domain: { slug: string; name: string };
};

const DomainIconComponent = (props: Props) => {
  const { domain } = props;
  switch (domain.slug) {
    case 'arts-and-humanities':
      return <ArtIcon desc={domain.name} />;
    case 'business':
      return <BriefcaseIcon desc={domain.name} />;
    case 'computer-science':
      return <CodeIcon desc={domain.name} />;
    case 'data-science':
      return <TrendingIcon desc={domain.name} />;
    case 'information-technology':
      return <LaptopIcon desc={domain.name} />;
    case 'health':
      return <HealthIcon desc={domain.name} />;
    case 'math-and-logic':
      return <MathIcon desc={domain.name} />;
    case 'personal-development':
      return <LaunchIcon desc={domain.name} />;
    case 'physical-science-and-engineering':
      return <ScienceIcon desc={domain.name} />;
    case 'social-sciences':
      return <MembersIcon desc={domain.name} />;
    case 'language-learning':
      return <GlobeIcon desc={domain.name} />;
    default:
      return null;
  }
};

export default DomainIconComponent;
